// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"786":"c9a53f64","787":"0f56bde6"}[chunkId] + ".chunk.js";
};